<template>
  <div class="text-center flex-wrap d-flex justify-center pa-8">
    <v-progress-circular
      indeterminate
      :color="spinnerColor"
      :size="50"
      :width="5"
    ></v-progress-circular>

    <span class="w-100 mt-3">{{ spinnerText }}...</span>
  </div>
</template>

<script>
  export default {
    name: 'LoadingSpinner',
    props: {
      spinnerColor: {
        type: String,
        default: "secondary"
      },
      spinnerText: {
        type: String,
        default: "Loading"
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/_utilities";
</style>